/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RootAliases {
  CONF_USUARIO_NOVA_SENHA_FRAGMENT = 'conf-usuario-nova-senha-fragment',
  CONF_USUARIO_NOVA_SENHA_ROUTE = 'conf-usuario-nova-senha-route',
  CONFIRMAR_USUARIO_FALHA_FRAGMENT = 'confirmar-usuario-falha-fragment',
  CONFIRMAR_USUARIO_FALHA_ROUTE = 'confirmar-usuario-falha-route',
  CONFIRMAR_USUARIO_FRAGMENT = 'confirmar-usuario-fragment',
  CONFIRMAR_USUARIO_ROUTE = 'confirmar-usuario-route',
  DESCREDITED_PROVIDER_FRAGMENT = 'descredited-provider-fragment',
  DESCREDITED_PROVIDER_ROUTE = 'descredited-provider-route',
  HEALTH_DECLARATION_CANCELATION_FRAGMENT = 'health-declaration-cancelation-fragment',
  HEALTH_DECLARATION_CANCELATION_ROUTE = 'health-declaration-cancelation-route',
  HEALTH_DECLARATION_DYNAMIC_FORM = 'health-declaration-dynamic-form',
  HEALTH_DECLARATION_DYNAMIC_FORM_FRAGMENT = 'health-declaration-dynamic-form-fragment',
  HEALTH_DECLARATION_FINALIZATION_FRAGMENT = 'health-declaration-finalization-fragment',
  HEALTH_DECLARATION_FINALIZATION_ROUTE = 'health-declaration-finalization-route',
  HEALTH_DECLARATION_INVALID_FRAGMENT = 'health-declaration-invalid-fragment',
  HEALTH_DECLARATION_INVALID_ROUTE = 'health-declaration-invalid-route',
  HEALTH_DECLARATION_LANDING_FRAGMENT = 'health-declaration-landing-fragment',
  HEALTH_DECLARATION_LANDING_ROUTE = 'health-declaration-landing-route',
  HEALTH_DECLARATION_VALID_FRAGMENT = 'health-declaration-valid-fragment',
  HEALTH_DECLARATION_VALID_ROUTE = 'health-declaration-valid-route',
  HEALTH_INSURANCE_FRAGMENT = 'health-insurance-fragment',
  HEALTH_INSURANCE_ROUTE = 'health-insurance-route',
  INACTIVITY_FRAGMENT = 'inactivity-fragment',
  INACTIVITY_ROUTE = 'inactivity-route',
  LAYOUT_ROOT = 'layout-root',
  LOGIN_FRAGMENT = 'login-fragment',
  LOGIN_ROUTE = 'login-route',
  NEW_PASSWORD_FRAGMENT = 'new-password-fragment',
  NEW_PASSWORD_ROUTE = 'new-password-route',
  PRODUCTS_BY_USER_FRAGMENT = 'products-by-user-fragment',
  PRODUCTS_BY_USER_ROUTE = 'products-by-user-route',
  REDIRECT_FRAGMENT = 'redirect-fragment',
  REDIRECT_ROUTE = 'redirect-route',
}
export { RootAliases };
